export default __webpack_public_path__ + "static/media/top_dots.4b986a01.png";